import { createChatBotMessage } from "react-chatbot-kit";
import chatbotData from "./chatbotData"; // your expanded JSON
import Options from "./Options";   
import BotAvatar from "./BotAvatar";


const config = {
  botName: "HGS",
  customComponents: {
    botAvatar: (props) => <BotAvatar {...props} />, // use custom avatar
  },
  initialMessages: [
    createChatBotMessage(chatbotData.start.message, {
      widget: "options",
      payload: { options: chatbotData.start.options },
    }),
  ],
  state: {
    currentId: "start",
  },
  widgets: [
    {
      widgetName: "options",
      widgetFunc: (props) => <Options {...props} />,
      mapStateToProps: ["currentId"],
    },
  ],
};

export default config;
